/* NZS-RAILS-0921: existing delegated mouse drag, shared arrow controls and vertical wheel routing. Native touch is preserved. */
(function () {
  'use strict';
  if (window.__nzsDragScroll) return;   // second include must not double-bind
  window.__nzsDragScroll = true;

  var DRAG_THRESHOLD = 4;    // px before a press becomes a drag
  var FRICTION = 0.94;       // per-frame velocity decay for the release glide
  var MAX_FLICK = 42;        // px/frame cap so a hard flick can't fling the whole rail
  var STOP_V = 0.35;         // px/frame below which the glide ends and snap re-engages

  function nowMs() {
    return (window.performance && performance.now) ? performance.now() : Date.now();
  }
  function prefersReduce() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* NZS-RAILS-0921: shared arrows, no progress bars and vertical-only wheel behaviour. */
  var GRAB='[data-nzs-grab],.nzs-vsw__sws--cards,.nzs-gthumbs,.nzs-pinfo__tabs,.nzs-pol__tabs,.nzs-tabs2__strip,.nzs-pinfo .nzs-nf,.nzs-tabs2 .nzs-nf,.nzs-qv__acc-b,.nzsc__tabs,.nzs-subc__row,.nzsc__scrollwrap,.nzs-oh__grid,.nzs-pw__grid,.rte .nzs-table-wrap,.rte table';
  var states=new Map(),serial=0;
  var nativeButtons='.nzs-bs__arrow,.nzs-cw__arrow,[data-nzsc-tabnav],.fpw__arrow,.nzs-revc__nav,.nzs-gal-arrow,.nzs-pdp-upsell__nav button';
  function decorate(button,dir){
    button.classList.add('nzs-scroll-arrow');button.setAttribute('data-nzs-scroll-dir',dir);
    if(button.hasAttribute('data-nzsc-tabnav')){button.removeAttribute('aria-hidden');button.removeAttribute('tabindex');if(!button.getAttribute('aria-label'))button.setAttribute('aria-label',Number(dir)<0?'Scroll tabs left':'Scroll tabs right');}
  }
  function nativeStyle(root){
    root.querySelectorAll(nativeButtons).forEach(function(b){
      var dir=b.getAttribute('data-dir')||b.getAttribute('data-nzsc-tabnav')||b.getAttribute('data-upsell-step');
      if(!dir)dir=/prev/.test(b.className)?'-1':'1';decorate(b,dir);
    });
  }
  function findRail(target,selector){
    if(!target||!target.closest)return null;
    var rail=target.closest(selector||GRAB);
    while(rail && rail.scrollWidth<=rail.clientWidth+1)rail=rail.parentElement&&rail.parentElement.closest(selector||GRAB);
    return rail;
  }
  function existingControls(el){
    var scope=null,selector=null;
    if(el.matches('.nzs-bs__track')){scope=el.closest('.nzs-bsw,.nzs-rvm');selector='.nzs-bs__nav';}
    if(el.matches('.nzs-cw__track')){scope=el.closest('.nzs-cw');selector='.nzs-cw__nav';}
    if(scope){var nav=scope.querySelector(selector);if(nav)return {nav:nav,buttons:Array.from(nav.querySelectorAll('button')),native:true};}
    if(el.matches('.nzsc__tabs')){var bs=el.parentElement.querySelectorAll('[data-nzsc-tabnav]');if(bs.length)return {nav:null,buttons:Array.from(bs),native:true};}
    // Featured flavour arrows also change the featured product; never disable or replace them.
    if(el.matches('.fpw__pills')){var section=el.closest('.shopify-section');var buttons=section&&section.querySelectorAll('.fpw__arrow');if(buttons&&buttons.length)return {nav:null,buttons:Array.from(buttons),native:true,keep:true};}
    return null;
  }
  function setupRail(el){
    if(states.has(el))return states.get(el);
    if(!el.clientWidth||!el.clientHeight)return null;
    var horizontal=/auto|scroll/.test(getComputedStyle(el).overflowX);
    if(!horizontal && !el.hasAttribute('data-nzs-grab'))return null;
    // A nested table should not get a second control row when its wrapper owns the overflow.
    var parent=el.parentElement&&el.parentElement.closest(GRAB);
    if(parent&&parent.scrollWidth>parent.clientWidth+1)return null;
    el.setAttribute('data-nzs-grab','');el.classList.add('nzs-hrail');
    if(!el.id)el.id='nzs-hrail-'+(++serial);
    var state=existingControls(el);
    if(!state){
      var nav=document.querySelector('[data-nzs-controls="'+el.id+'"]');
      if(!nav){nav=document.createElement('div');nav.className='nzs-rail-nav';nav.setAttribute('data-nzs-controls',el.id);el.parentNode.insertBefore(nav,el);}
      nav.setAttribute('role','group');nav.setAttribute('aria-label','Horizontal scrolling controls');
      var buttons=Array.from(nav.querySelectorAll('button[data-nzs-rail-step]')); /* NZS-SPD-0927-B2-2c adopt: a server-rendered pair (snippets/nzs-rail-nav.liquid, the flavour rail HTML) is kept as-is; any other shape, the drawer's empty nav included, is rebuilt exactly as before */
      if(buttons.length!==2){nav.innerHTML='';buttons=[];
      [-1,1].forEach(function(dir){var b=document.createElement('button');b.type='button';b.setAttribute('data-nzs-rail-step',dir);b.setAttribute('data-nzs-target',el.id);b.setAttribute('aria-controls',el.id);b.setAttribute('aria-label',el.id==='nzsCdrRecsRow'?(dir<0?'Previous recommendations':'Next recommendations'):(dir<0?'Scroll left':'Scroll right'));b.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="'+(dir<0?'m15 6-6 6 6 6':'m9 6 6 6-6 6')+'"/></svg>';decorate(b,dir);nav.appendChild(b);buttons.push(b);});} /* NZS-SPD-0927-B2-2c adopt-end */
      state={nav:nav,buttons:buttons,native:false};
    }
    if(state.nav)state.nav.setAttribute('data-nzs-scroll-nav','');
    state.buttons.forEach(function(b,i){decorate(b,b.getAttribute('data-dir')||b.getAttribute('data-nzsc-tabnav')||(i?1:-1));b.setAttribute('aria-controls',el.id);});
    states.set(el,state);if(sizeObserver)sizeObserver.observe(el);return state;
  }
  function renderRail(el){
    var state=setupRail(el);if(!state)return;
    var max=el.scrollWidth-el.clientWidth,overflow=el.clientWidth>0&&el.clientHeight>0&&max>2&&!el.closest('[hidden],[inert]');
    el.classList.toggle('nzs-grab-on',overflow);
    if(state.keep)return;
    if(state.nav)state.nav.hidden=!overflow;
    var rtl=getComputedStyle(el).direction==='rtl',position=rtl?-el.scrollLeft:el.scrollLeft;
    state.buttons.forEach(function(b){if(!state.nav)b.hidden=!overflow;var dir=Number(b.getAttribute('data-nzs-scroll-dir'));b.disabled=!overflow||(dir<0?position<=1:position>=max-1);});
  }
  function renderAll(root){
    root=root&&root.querySelectorAll?root:document;
    states.forEach(function(s,el){if(!el.isConnected){if(sizeObserver)sizeObserver.unobserve(el);if(!s.native&&s.nav.isConnected)s.nav.remove();states.delete(el);}});
    nativeStyle(root);
    root.querySelectorAll('.splide__track').forEach(function(el){el.classList.toggle('nzs-native-hrail',el.clientWidth>0&&el.scrollWidth>el.clientWidth+2&&/auto|scroll/.test(getComputedStyle(el).overflowX));});
    root.querySelectorAll(GRAB).forEach(renderRail);
    if(root.matches&&root.matches(GRAB))renderRail(root);
  }
  var sizeObserver=window.ResizeObserver?new ResizeObserver(function(entries){entries.forEach(function(entry){renderRail(entry.target);});}):null;
  window.nzsRefreshRails=renderAll;
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('[data-nzs-rail-step]');if(!b||b.disabled)return;
    var rail=document.getElementById(b.getAttribute('data-nzs-target'));if(!rail)return;
    stopGlide();
    var child=Array.from(rail.children).find(function(c){return c.getBoundingClientRect().width>10&&c.tagName!=='SCRIPT';});
    var width=child?child.getBoundingClientRect().width:0,gap=parseFloat(getComputedStyle(rail).columnGap)||0;
    var step=width>0&&width<rail.clientWidth?width+gap:rail.clientWidth*.8;
    var direction=Number(b.getAttribute('data-nzs-rail-step'))*(getComputedStyle(rail).direction==='rtl'?-1:1);
    rail.scrollBy({left:step*direction,behavior:prefersReduce()?'auto':'smooth'});
  });
  function verticalWheel(rail,delta){
    if(!delta)return;
    for(var p=rail.parentElement;p;p=p.parentElement){
      var style=getComputedStyle(p),max=p.scrollHeight-p.clientHeight;
      if(/auto|scroll/.test(style.overflowY)&&max>1){
        if((delta>0&&p.scrollTop<max-1)||(delta<0&&p.scrollTop>1)){
          var previous=p.style.scrollBehavior;p.style.scrollBehavior='auto';p.scrollTop+=delta;p.style.scrollBehavior=previous;return;
        }
        if(/contain|none/.test(style.overscrollBehaviorY))return;
      }
      if(p.matches('[aria-modal="true"],.nzs-cart-drawer,.nzs-mnav'))return;
    }
    if(/hidden|clip/.test(getComputedStyle(document.body).overflowY))return;
    var page=document.scrollingElement,previous=page.style.scrollBehavior;page.style.scrollBehavior='auto';page.scrollTop+=delta;page.style.scrollBehavior=previous;
  }
  document.addEventListener('wheel',function(e){
    if(e.ctrlKey)return; // preserve browser pinch/zoom
    var rail=findRail(e.target,GRAB+',.splide__track');if(!rail)return;
    e.preventDefault();stopGlide();
    var delta=e.deltaY*(e.deltaMode===1?16:e.deltaMode===2?rail.clientHeight:1);
    verticalWheel(rail,delta); // deltaX intentionally never moves a horizontal rail
  },{capture:true,passive:false});


  /* ---------- park / restore the scroller's snap + smooth for manual control ---------- */

  function parkFor(el) {
    return { snap: el.style.scrollSnapType, beh: el.style.scrollBehavior };
  }
  function applyPark(el) {
    /* scroll-snap fights a manual scrollLeft write; scroll-behavior:smooth makes each write animate.
       Both must be off for the drag to track the pointer 1:1. */
    el.style.scrollSnapType = 'none';
    el.style.scrollBehavior = 'auto';
  }
  function restorePark(el, saved) {
    /* restore behaviour BEFORE snap so the re-snap (triggered by re-enabling mandatory snap) can
       animate smoothly to the nearest card. */
    if (saved.beh) { el.style.scrollBehavior = saved.beh; } else { el.style.removeProperty('scroll-behavior'); }
    if (saved.snap) { el.style.scrollSnapType = saved.snap; } else { el.style.removeProperty('scroll-snap-type'); }
  }

  /* ---------- grab-to-drag on the scroller (mouse only) ---------- */

  var drag = null;    // { el, startX, startLeft, moved, saved, lastX, lastT, vx, target, raf }
  var glide = null;   // { el, raf, saved }  -- an in-flight release momentum animation

  function stopGlide() {
    if (!glide) return;
    if (glide.raf) cancelAnimationFrame(glide.raf);
    restorePark(glide.el, glide.saved);
    renderRail(glide.el);
    glide = null;
  }

  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    var el = findRail(e.target);
    if (!el || e.target.closest('input,textarea,select,[contenteditable="true"],.nzs-rail-nav')) return;            // the rail has its own handler below
    if (el.scrollWidth - el.clientWidth <= 1) return;
    /* Grabbing mid-glide cancels the momentum (and restores snap/smooth); the drag re-parks them on
       its first real move. */
    stopGlide();
    /* No preventDefault here: a plain click on a card/link/Quick-add must still work. The drag
       only takes over once the pointer has actually travelled DRAG_THRESHOLD px. */
    drag = { el: el, startX: e.clientX, startLeft: el.scrollLeft, moved: false, saved: null,
             lastX: e.clientX, lastT: nowMs(), vx: 0, target: el.scrollLeft, raf: 0 };
  });

  function applyDrag() {
    if (!drag) return;
    drag.raf = 0;
    drag.el.scrollLeft = drag.target;
    renderRail(drag.el);
  }

  document.addEventListener('pointermove', function (e) {
    if (!drag) return;
    /* button released outside the viewport: no pointerup ever arrives, so the first
       buttons-free move is the release signal */
    if (e.buttons === 0) return endDrag();
    var dx = e.clientX - drag.startX;
    if (!drag.moved) {
      if (Math.abs(dx) <= DRAG_THRESHOLD) return;
      drag.moved = true;
      drag.el.classList.add('nzs-grabbing');
      drag.saved = parkFor(drag.el);
      applyPark(drag.el);
    }
    /* pointer velocity, sampled per event in px/ms -- feeds the release glide */
    var t = nowMs();
    var dt = t - drag.lastT;
    if (dt > 0) {
      drag.vx = (e.clientX - drag.lastX) / dt;
      drag.lastX = e.clientX;
      drag.lastT = t;
    }
    /* defer the actual scroll write + rail redraw to one frame, coalescing bursts of high-frequency
       pointermove events into a single reflow per frame */
    drag.target = drag.startLeft - dx;
    if (!drag.raf) drag.raf = requestAnimationFrame(applyDrag);
    e.preventDefault();   // mouse only -- never reached for touch/pen
  });

  function endDrag(event) {
    var cancelled=event && /^(blur|pointercancel|visibilitychange)$/.test(event.type);
    if (!drag){if(cancelled)stopGlide();return;}
    var d = drag;
    drag = null;
    if (d.raf) { cancelAnimationFrame(d.raf); d.el.scrollLeft = d.target; }
    /* cleanup runs unconditionally: a stale nzs-grabbing (e.g. release outside the window)
       would leave the row's images pointer-events:none until the next full drag */
    d.el.classList.remove('nzs-grabbing');
    if (!d.moved) return;
    if(cancelled || !d.el.isConnected){restorePark(d.el,d.saved);stopGlide();return;}
    /* Swallow the click the browser fires at the end of the drag gesture -- otherwise releasing
       on a card would follow its link. Flag + permanent capture listener (not a self-removing
       one): the flag is set only when a real drag just ended, cleared on the next pointerdown,
       so it can never eat an unrelated later click, and it wins regardless of whether the
       browser dispatches the click before or after a timeout task. */
    justDragged = d.el;
    setTimeout(function () { if(justDragged===d.el)justDragged=null; }, 120);

    /* scroll velocity is OPPOSITE the pointer's clientX velocity: dragging left lowers clientX
       (vx < 0) but raises scrollLeft, so the momentum that continues that scroll is -vx. */
    var v = nowMs()-d.lastT>80?0:-d.vx * 16.67;   // px/ms -> px/frame
    if (v > MAX_FLICK) v = MAX_FLICK; else if (v < -MAX_FLICK) v = -MAX_FLICK;

    /* Weak flick or reduced-motion: no glide, just restore snap+smooth and let the browser snap. */
    if (prefersReduce() || Math.abs(v) < 1.2) {
      restorePark(d.el, d.saved);
      setTimeout(function () { renderRail(d.el); }, 0);   // let the snap settle, then redraw
      return;
    }

    /* Momentum: keep snap+smooth parked, glide with friction, restore (=> re-snap) at rest. */
    var el = d.el;
    glide = { el: el, raf: 0, saved: d.saved };
    var maxScroll = el.scrollWidth - el.clientWidth;
    function step() {
      if (!glide) return;
      if(!el.isConnected || document.hidden){stopGlide();return;}
      v *= FRICTION;
      var next = el.scrollLeft + v;
      if (next <= 0) { el.scrollLeft = 0; return stopGlide(); }
      if (next >= maxScroll) { el.scrollLeft = maxScroll; return stopGlide(); }
      el.scrollLeft = next;
      renderRail(el);
      if (Math.abs(v) < STOP_V) return stopGlide();
      glide.raf = requestAnimationFrame(step);
    }
    glide.raf = requestAnimationFrame(step);
  }

  var justDragged = null;
  document.addEventListener('pointerdown',function(){justDragged=null;},true);
  document.addEventListener('click', function (ev) {
    if (!justDragged || ev.detail===0 || !justDragged.contains(ev.target)) return;
    justDragged = null;
    ev.stopImmediatePropagation();
    ev.preventDefault();
  }, true);

  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);
  window.addEventListener('blur', endDrag);
  document.addEventListener('visibilitychange',function(){if(document.hidden){endDrag({type:'visibilitychange'});stopGlide();}});

  /* NZS-GRAB-IMG-0901 (Blake): let the mouse grab-drag begin on the card IMAGE too.
     Native <img>/<a> dragging fires on pointerdown-over-the-photo and pre-empts the
     pointermove stream, so a press starting on the image never became a swipe. Cancel
     the browser's native drag anywhere inside a grabber. */
  document.addEventListener('dragstart', function (e) {
    if (e.target && e.target.closest && e.target.closest(GRAB)) e.preventDefault();
  });

  /* ---------- keep the rail in sync ---------- */

  /* scroll does not bubble, but it does capture -- so one capture-phase listener covers every
     scroller on the page, including ones injected later. */
  document.addEventListener('scroll', function (e) {
    var el = e.target;
    if (el && el.nodeType === 1 && el.matches && el.matches(GRAB)) renderRail(el);
  }, true);

  /* Trailing debounce, NOT rAF: renderAll() reads scrollWidth/clientWidth, so running it once per
     animation frame off a whole-document MutationObserver would force a reflow every frame on an
     Alpine-heavy page. Live scrolling is already covered by the capture listener above; this path
     only needs to catch "the DOM changed, re-measure eventually". */
  var timer = null;
  function schedule() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () { timer = null; renderAll(); }, 150);
  }

  window.addEventListener('resize', schedule);
  window.addEventListener('load', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('nzs:cart-rendered',schedule);
  document.addEventListener('click',function(e){if(e.target.closest&&e.target.closest('button,summary,[role="tab"]'))schedule();});
  document.addEventListener('focusin',function(e){var el=findRail(e.target);if(el)renderRail(el);});

  /* ponytail: the whole-document childList+subtree observer is deleted — it ran on EVERY DOM
     mutation of every page (an Alpine-heavy storefront mutates constantly) just to keep rail
     geometry "eventually" fresh. The grab cursor and rail only matter while the pointer is over
     the scroller, so re-measure exactly then: one delegated enter-style pointerover. Scrolling
     already redraws via the capture scroll listener; sizing via resize/load/section:load/DCL. */
  document.addEventListener('pointerover', function (e) {
    var el = e.target.closest && e.target.closest(GRAB);
    if (el && (!e.relatedTarget || !el.contains(e.relatedTarget))) renderRail(el);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();
